<template>
  <div class="contacts">
    <div class="page-title">Contact Us</div>
    <div class="headquarters">
      <h5>Headquarters</h5>
      <div class="row">
        <div class="col-md-5 col-12">
          <p class="p-0">666 East Quaker Str., Suite 1</p>
          <p class="p-0">Orchard Park, NY 14127</p>
        </div>
        <div class="col-md-5 col-12">
          <p class="p-0">Phone: <strong>1-800-922-0957 (option 2)</strong></p>
          <p class="p-0">Fax: <strong>716-508-8254</strong></p>
          <p class="p-0">email: <strong>Support@{{siteName}}.com</strong></p>
        </div>
      </div>
    </div>
    <div class="question-form">
      <h5>Send us Question</h5>
      <small>* Indicates required field</small>
      <p>To help us respond to you with the most accurate answer or assistance, please begin by selecting a department or topic from the drop down below.</p>
      <b-form-select v-if="!form.topic" v-model="form.topic"
                     :options="topicsList"
                     calss="mb-3"
      ></b-form-select>
      <form v-if="form.topic">
        <b-button variant="link" v-on:click.native="form.topic=''">< Select a different Department or Topic</b-button>
        <b-form-fieldset
          label="Department, Topic or Issue:"
          :label-size="1">
          <b-form-input class="topic" :static="true" v-model="form.topic" type="text"></b-form-input>
        </b-form-fieldset>
        <b-form-fieldset
          label="Name: *"
          class="custom"
          :state="form.name.length?'success':'warning'"
          :label-size="1">
          <b-form-input v-model="form.name" type="text" placeholder="Enter  Name"></b-form-input>
        </b-form-fieldset>
        <b-form-fieldset
          label="Email Address: *"
          :state="form.email.length?'success':'warning'"
          :label-size="1">
          <b-form-input v-model="form.email" type="email" placeholder="Enter Email Address"></b-form-input>
        </b-form-fieldset>
        <b-form-fieldset
          label="Type your Question or Inquiry: *"
          :state="form.question.length?'success':'warning'"
          :label-size="1">
          <b-form-input v-model="form.question" textarea :rows="5"></b-form-input>
        </b-form-fieldset>
        <button class="button-primary">Submit</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data () {
    return {
      topicsList: [{
        text: 'Please choose a Department/Topic:*',
        value: ''
      }, 'Billing', 'Editorial', 'External Affairs', 'Altmetric', 'Other'],
      form: {
        topic: '',
        title: '',
        name: '',
        email: '',
        question: ''
      },
      siteName: process.env.SITE_NAME
    }
  }
}
</script>


<style scoped lang="scss">
  .contacts {
    font-family: 'Open Sans';
    .has-warning.custom {
      .col-form-label{
        color: $red
      }
    }

    .headquarters{
      margin: 30px 0px;
      padding-bottom: 30px;
      border-bottom: 1px solid $grey-border;
      p {
        margin: 0px;
      }
    }

    .question-form{
      &>p{
        font-family: 'Open Sans Condensed', sans-serif;
      }
      small{
        display: block;
        margin: 15px 0;
        font-style: italic;
      }
    }

    .topic {
      font-weight: 600;
      fornt-size: 16px;
    }
    form {
      .btn-link{
        padding-left: 0px;
      }
      label{
        font-style: italic;
      }
    }
  }
  .custom{

  }
</style>



// WEBPACK FOOTER //
// ContactPage.vue?2a0516c9